
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Article } from "@/components/reader-home/types";
import ArticleCard from "@/components/journalist-profile/shared/ArticleCard";
import { transformToJournalistArticle } from '@/utils/articleTransformUtils';

interface ContentSectionProps {
  title: string;
  articles: Article[];
  emptyStateMessage?: string;
  emptyStateAction?: React.ReactNode;
  suggestedArticles?: Article[];
}

const ContentSection: React.FC<ContentSectionProps> = ({ 
  title, 
  articles, 
  emptyStateMessage = "No articles found", 
  emptyStateAction,
  suggestedArticles = []
}) => {
  if (articles.length === 0) {
    return (
      <section>
        <h2 className="text-xl font-bold mb-6">{title}</h2>
        
        <div className="py-8 text-center border border-dashed border-border rounded-lg mb-8">
          <AlertCircle className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
          <h3 className="text-lg font-medium mb-2">{emptyStateMessage}</h3>
          {emptyStateAction}
        </div>
        
        {suggestedArticles.length > 0 && (
          <>
            <h3 className="text-lg font-medium mb-4">Suggested Articles</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {suggestedArticles.slice(0, 3).map(article => (
                <ArticleCard 
                  key={article.id} 
                  article={transformToJournalistArticle(article)} 
                />
              ))}
            </div>
          </>
        )}
      </section>
    );
  }

  return (
    <section>
      <h2 className="text-xl font-bold mb-6">{title}</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {articles.map(article => (
          <ArticleCard 
            key={article.id} 
            article={transformToJournalistArticle(article)}
            showLead={true}
          />
        ))}
      </div>
    </section>
  );
};

export default ContentSection;
